import { MealTypes } from 'const/mealTypes';
import { RootState } from 'redux/types';
import { Recipe } from 'types/types';

export const getRecipeList = (store: RootState): Recipe[] => store.recipe.recipes;
export const getCurrentDate = (store: RootState): Date => store.recipe.currentDate;
export const getCurrentMealType = (store: RootState): MealTypes => store.recipe.currentMealType;
